import { getAuth } from "firebase/auth";

const getFirebaseAuthToken = async () => {
    const auth = getAuth();
    const authorizedUser = auth.currentUser;
    if (!authorizedUser) throw new Error("Google account not authenticated");
    return await authorizedUser.getIdToken();
};

export default getFirebaseAuthToken;
